import type { WModuleGroupView, WModuleView } from '@zola/svc-web-api-ts-client';
import { RootState } from '../reducers';

export const getModuleGroups = (state: RootState): WModuleGroupView[] =>
  state.moduleGroups.views || [];

export const getModuleGroupsStatus = (state: RootState): boolean => state.moduleGroups.busy;

export const getModuleGroupByName = (state: RootState, name: string): WModuleGroupView => {
  const moduleGroups = getModuleGroups(state);
  return moduleGroups.find((group) => group.name === name) || {};
};

export const getModuleGroupModuleView = (module: WModuleGroupView): WModuleView[] =>
  module.moduleViews || [];
